<template>
  <pop-view @onCloseClick="onCloseClick">
    <div class="add-device">
      <div class="add-device-top">
        <p class="add-device-top-title">{{ isEditMode ? '编辑预约' : '新增预约' }}</p>
        <img
          class="add-device-top-close"
          src="@imgs/close-card.png"
          @click="onCloseClick"
        />
      </div>
      <div class="add-device-middle">
        <div class="add-device-middle-user">
          <p class="add-device-middle-user-title"><span class="required">*</span>选择用户：</p>
        <div class="add-device-middle-user-search-container" ref="searchContainer">
          <div class="user-search" :class="{ active: isInputActive }">
            <input
              class="user-search-input"
              type="text"
              ref="userSearchInput"
              v-model="userSearchKeyword"
              placeholder="请选择"
              @blur="onInputBlur"
              @click="onInputClick"
              :readonly="selectedUserIndex !== undefined"
            />
            <button class="user-search-search" @click="onSearchClick" v-show="selectedUserIndex === undefined">搜索</button>
            <button class="user-search-clear" @click="onDeleteSelectedUser" v-show="selectedUserIndex !== undefined">✕</button>
          </div>
          <!-- 用户搜索列表 -->
          <div v-show="showUserList && userList.length > 0" class="user-list-container" ref="userListContainer">
            <div class="user-list">
              <div 
                v-for="(user, index) in userList" 
                :key="index"
                class="user-list-item"
                @click="onSelectUser(index)"
              >
                <div class="user-item-info">
                  <p class="user-item-name">{{ user.name }}  {{ user.gender }} {{ user.age }}</p>
                  <!-- <p class="user-item-details">性别：{{ user.gender }} | 手机号：{{ user.mobile }}</p>
                  <p class="user-item-date">{{ user.date }}</p> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div class="add-device-middle-device">
          <p class="add-device-middle-device-title">预绑信息</p>
          <div class="add-device-middle-device-search-container" ref="deviceSearchContainer">
            <div class="device-search" :class="{ active: isDeviceInputActive }">
              <input
                class="device-search-input"
                type="text"
                ref="deviceSearchInput"
                v-model="deviceSearchKeyword"
                placeholder="请选择预绑信息"
                @blur="onDeviceInputBlur"
                @click="onDeviceInputClick"
                :readonly="selectedDeviceIndex !== undefined"
              />
              <button class="device-search-search" @click="onDeviceSearchClick" v-show="selectedDeviceIndex === undefined">搜索</button>
              <button class="device-search-clear" @click="onDeleteSelectedDevice" v-show="selectedDeviceIndex !== undefined">✕</button>
            </div>
            <!-- 设备搜索列表 -->
            <div v-show="showDeviceList && deviceList.length > 0" class="device-list-container" ref="deviceListContainer">
              <div class="device-list">
                <div 
                  v-for="(device, index) in deviceList" 
                  :key="index"
                  class="device-list-item"
                  @click="onSelectDevice(index)"
                >
                  <div class="device-item-info">
                    <p class="device-item-name">{{ device.sn }}</p>
                    <p class="device-item-details">{{ device.userStatusDesc }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="add-device-middle-appointment-date">
          <p class="add-device-middle-appointment-date-title"><span class="required">*</span>预约日期：</p>
          <div class="add-device-middle-appointment-date-container">
            <el-select
              filterable
              v-model="appointmentYear"
              placeholder="年"
              :popper-append-to-body="false"
              @visible-change="appointmentYearChange"
              ref="appointmentYearSelect"
              class="add-device-middle-appointment-date-year"
            >
              <el-option
                v-for="item in appointmentYearList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              filterable
              v-model="appointmentMonth"
              placeholder="月"
              :popper-append-to-body="false"
              @visible-change="appointmentMonthChange"
              ref="appointmentMonthSelect"
              class="add-device-middle-appointment-date-month"
            >
              <el-option
                v-for="item in appointmentMonthList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              filterable
              v-model="appointmentDay"
              placeholder="日"
              :popper-append-to-body="false"
              @visible-change="appointmentDayChange"
              ref="appointmentDaySelect"
              class="add-device-middle-appointment-date-day"
            >
              <el-option
                v-for="item in appointmentDayList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="add-device-middle-remark">
          <p class="add-device-middle-remark-title">备注：</p>
          <el-input
            v-model="remark"
            type="textarea"
            placeholder="请输入备注"
            class="add-device-middle-remark-textarea"
            :rows="3"
          >
          </el-input>
        </div>
      </div>
      <div class="add-device-bottom">
        <button class="add-device-bottom-cancel" @click="onCancelClick">取消</button>
        <button class="add-device-bottom-confirm" @click="onConfirmClick">
          确定
        </button>
      </div>
    </div>
    
  </pop-view>
</template>

<script>
import BorderInput from "@c/common/border-input.vue";
import PopView from "@c/common/pop-view.vue";
import { Select, Option, DatePicker, RadioGroup, Radio, Input } from "element-ui";


export default {
  components: {
    PopView,
    BorderInput,
    ElSelect: Select,
    ElOption: Option,
    ElDatePicker: DatePicker,
    ElRadioGroup: RadioGroup,
    ElRadio: Radio,
    ElInput: Input,
  },

  props: {
    editData: {
      type: Object,
      default: null
    },
    hospitalId: {
      type: [String, Number],
      required: true
    }
  },

  data: function () {
    return {
      userId: "",
      appointmentDate: "",
      remark: "",
      selectedDeviceId: undefined,
      rawUserList: [],
      rawDeviceList: [],
      deviceSearchLoading: false,
      deviceSearchKeyword: "",
      selectedDeviceIndex: undefined,
      selectedDeviceInfo: null, // 保存选中设备的完整信息
      isDeviceInputActive: false,
      showDeviceList: false,
      userSearchLoading: false,
      userSearchKeyword: "",
      selectedUserIndex: undefined,
      selectedUserInfo: null, // 保存选中用户的完整信息
      isInputActive: false,
      showUserList: false,
      // 预约日期相关
      appointmentYear: "",
      appointmentMonth: "",
      appointmentDay: "",
      appointmentYearList: [],
      appointmentMonthList: [],
      appointmentDayList: [],
    };
  },

  computed: {
    isEditMode: function () {
      return this.editData !== null;
    },

    userList: function () {
      const tempArray = [];
      for (const rawItem of this.rawUserList) {
        const item = {
          name: rawItem.trueName,
          gender: rawItem.sex === 1 ? '男' : rawItem.sex === 2 ? '女' : '未知',
          mobile: rawItem.mobile,
          date: "添加时间：" + (rawItem.gmtCreate || ''),
          uid: rawItem.id,
          age: rawItem.age+'岁',
        };
        tempArray.push(item);
      }
      return tempArray;
    },

    deviceList: function () {
      const tempArray = [];
      for (const rawItem of this.rawDeviceList) {
        const item = {
          sn: rawItem.sn,
          userStatusDesc: rawItem.userStatusDesc || '',
          id: rawItem.id,
        };
        tempArray.push(item);
      }
      return tempArray;
    },

    selectedDevice: function () {
      if (this.selectedDeviceIndex === undefined) {
        return {
          id: "",
          sn: "",
          userStatusDesc: "",
        };
      } else if (this.selectedDeviceInfo) {
        // 如果有保存的设备信息，直接返回
        return this.selectedDeviceInfo;
      } else {
        const rawDevice = this.rawDeviceList[this.selectedDeviceIndex];
        if (rawDevice) {
          return {
            id: rawDevice.id,
            sn: rawDevice.sn,
            userStatusDesc: rawDevice.userStatusDesc || '',
          };
        } else {
          return {
            id: "",
            sn: "",
            userStatusDesc: "",
          };
        }
      }
    },

    selectedUser: function () {
      if (this.selectedUserIndex === undefined) {
        return {
          uid: "",
          name: "",
          gender: "",
          mobile: "",
        };
      } else if (this.selectedUserInfo) {
        // 如果有保存的用户信息，直接返回
        return this.selectedUserInfo;
      } else {
        const rawUser = this.rawUserList[this.selectedUserIndex];
        if (rawUser) {
          return {
            uid: rawUser.id,
            name: rawUser.trueName,
            gender: rawUser.sex === 1 ? '男' : rawUser.sex === 2 ? '女' : '未知',
            mobile: rawUser.mobile,
          };
        } else {
          return {
            uid: "",
            name: "",
            gender: "",
            mobile: "",
          };
        }
      }
    },
  },

  async mounted() {
    this.initializeAppointmentDate();
    if (this.isEditMode) {
      this.initializeEditData();
    }
  },

  methods: {
    onCloseClick: function () {
      this.$emit("onCloseClick");
    },

    onInputBlur: function () {
      this.isInputActive = false;
      // 延迟隐藏列表，确保点击事件能触发
      setTimeout(() => {
        this.showUserList = false;
      }, 200);
    },

    onInputClick: function () {
      this.isInputActive = true;
    },

    onSearchClick: function () {
      this.isInputActive = true;
      let $input = this.$refs.userSearchInput;
      $input.focus();
      this.userSearchLoading = true;
      const keyword = this.userSearchKeyword.trim();
      this.searchUsers(keyword);
    },

    onSelectUser: function (index) {
      this.selectedUserIndex = index;
      // 在清空rawUserList之前先获取用户信息
      const selectedUser = this.userList[index];
      this.selectedUserInfo = selectedUser; // 保存完整的用户信息
      this.userId = selectedUser.uid;
      this.userSearchKeyword = selectedUser.name;
      this.showUserList = false;
      // 清空搜索列表
      this.rawUserList = [];
    },

    onDeleteSelectedUser: function () {
      this.selectedUserIndex = undefined;
      this.selectedUserInfo = null;
      this.userId = "";
      this.userSearchKeyword = "";
      this.rawUserList = [];
    },

    async searchUsers(keyword = '') {
      try {
        const params = {
          pageNum: 1,
          pageSize: 20,
          keyWord: keyword,
          hospitalId: this.hospitalId
        };
        const response = await this.$api.getUserPageList(params);
        this.rawUserList = response.list || [];
        
        // 显示搜索结果
        if (this.rawUserList.length > 0) {
          this.showUserList = true;
        } else {
          this.showUserList = false;
          this.$toast.showRed('未找到匹配的用户');
        }
      } catch (error) {
        console.error('搜索用户失败:', error);
        this.$toast.showRed('搜索用户失败');
        this.rawUserList = [];
        this.showUserList = false;
      } finally {
        this.userSearchLoading = false;
      }
    },

    onDeviceInputBlur: function () {
      this.isDeviceInputActive = false;
      // 延迟隐藏列表，确保点击事件能触发
      setTimeout(() => {
        this.showDeviceList = false;
      }, 200);
    },

    onDeviceInputClick: function () {
      this.isDeviceInputActive = true;
    },

    onDeviceSearchClick: function () {
      this.isDeviceInputActive = true;
      let $input = this.$refs.deviceSearchInput;
      $input.focus();
      this.deviceSearchLoading = true;
      const keyword = this.deviceSearchKeyword.trim();
      this.searchDevices(keyword);
    },

    onSelectDevice: function (index) {
      this.selectedDeviceIndex = index;
      // 在清空rawDeviceList之前先获取设备信息
      const selectedDevice = this.deviceList[index];
      this.selectedDeviceInfo = selectedDevice; // 保存完整的设备信息
      this.selectedDeviceId = selectedDevice.sn;
      this.deviceSearchKeyword = selectedDevice.sn;
      this.showDeviceList = false;
      // 清空搜索列表
      this.rawDeviceList = [];
    },

    onDeleteSelectedDevice: function () {
      this.selectedDeviceIndex = undefined;
      this.selectedDeviceInfo = null;
      this.selectedDeviceId = undefined;
      this.deviceSearchKeyword = "";
      this.rawDeviceList = [];
    },

    async searchDevices(keyword = '') {
      try {
        const params = {
          sn: keyword,
          pageNum: 1,
          pageSize: 20,
          hospitalId: this.hospitalId
        };
        const response = await this.$api.getDeviceList(params);
        this.rawDeviceList = response.list || [];
        
        // 显示搜索结果
        if (this.rawDeviceList.length > 0) {
          this.showDeviceList = true;
        } else {
          this.showDeviceList = false;
          this.$toast.showRed('未找到匹配的设备');
        }
      } catch (error) {
        console.error('搜索设备失败:', error);
        this.$toast.showRed('搜索设备失败');
        this.rawDeviceList = [];
        this.showDeviceList = false;
      } finally {
        this.deviceSearchLoading = false;
      }
    },

    onCancelClick: function () {
      this.onCloseClick();
    },

    initializeAppointmentDate() {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth() + 1;
      const currentDay = today.getDate();
      
      // 默认选中今天
      this.appointmentYear = `${currentYear}年`;
      this.appointmentMonth = `${currentMonth}月`;
      this.appointmentDay = `${currentDay}日`;
      
      this.calculateAppointmentYear();
      this.calculateAppointmentMonth();
      this.calculateAppointmentDay(this.appointmentMonth);
    },

    appointmentYearChange(item) {
      if (item) {
        this.$refs.appointmentYearSelect.focus();
      } else {
        this.$refs.appointmentYearSelect.blur();
      }
    },

    appointmentMonthChange(item) {
      if (item) {
        this.$refs.appointmentMonthSelect.focus();
      } else {
        this.$refs.appointmentMonthSelect.blur();
      }
    },

    appointmentDayChange(item) {
      if (item) {
        this.$refs.appointmentDaySelect.focus();
      } else {
        this.$refs.appointmentDaySelect.blur();
      }
    },

    calculateAppointmentYear() {
      const today = new Date();
      const currentYear = today.getFullYear();
      this.appointmentYearList = [];
      
      // 生成今年及未来几年的选项
      for (let index = currentYear; index <= currentYear + 5; index++) {
        this.appointmentYearList.push({ value: `${index}年`, label: `${index}年` });
      }
    },

    calculateAppointmentMonth() {
      this.appointmentMonthList = [];
      for (let index = 1; index <= 12; index++) {
        this.appointmentMonthList.push({ value: `${index}月`, label: `${index}月` });
      }
    },

    calculateAppointmentDay(month) {
      if (
        month == "1月" ||
        month == "3月" ||
        month == "5月" ||
        month == "7月" ||
        month == "8月" ||
        month == "10月" ||
        month == "12月"
      ) {
        this.cycleAppointmentDay(31);
      } else {
        if (month == "2月") {
          const year = parseInt(this.appointmentYear.replace("年", ""));
          if (year % 4 === 0) {
            this.cycleAppointmentDay(29);
          } else {
            this.cycleAppointmentDay(28);
          }
        } else {
          this.cycleAppointmentDay(30);
        }
      }
    },

    cycleAppointmentDay(value) {
      this.appointmentDayList = [];
      for (let index = 1; index <= value; index++) {
        this.appointmentDayList.push({ value: `${index}日`, label: `${index}日` });
      }
      // 如果当前选中的日期超过了新月份的最大日期，则重置为1日
      const currentDay = parseInt(this.appointmentDay.replace("日", ""));
      if (currentDay > value) {
        this.appointmentDay = "1日";
      }
    },

    initializeEditData() {
      if (this.editData) {
        // 设置用户信息
        this.selectedUserIndex = 0;
        this.selectedUserInfo = {
          uid: this.editData.userId,
          name: this.editData.trueName,
          gender: this.editData.sex === 1 ? '男' : this.editData.sex === 2 ? '女' : '未知',
          mobile: this.editData.mobile
        };
        this.userId = this.editData.userId;
        this.userSearchKeyword = this.editData.trueName;
        
        // 设置预约日期
        if (this.editData.appointmentDate) {
          const date = new Date(this.editData.appointmentDate);
          this.appointmentYear = `${date.getFullYear()}年`;
          this.appointmentMonth = `${date.getMonth() + 1}月`;
          this.appointmentDay = `${date.getDate()}日`;
          
          // 重新计算日期选项
          this.calculateAppointmentYear();
          this.calculateAppointmentMonth();
          this.calculateAppointmentDay(this.appointmentMonth);
        }
        
        // 设置设备信息
        if (this.editData.deviceSn) {
          this.selectedDeviceIndex = 0;
          this.selectedDeviceInfo = {
            id: this.editData.deviceId || '',
            sn: this.editData.deviceSn,
            userStatusDesc: this.editData.deviceStatus || ''
          };
          this.selectedDeviceId = this.editData.deviceSn;
          this.deviceSearchKeyword = this.editData.deviceSn;
        }
        
        // 设置备注
        this.remark = this.editData.remark || '';
      }
    },

    onConfirmClick: function () {
      if (this.selectedUserIndex === undefined || !this.userId) {
        this.$toast.showRed("请先搜索并选择用户");
        return;
      }
      if (!this.appointmentYear || !this.appointmentMonth || !this.appointmentDay) {
        this.$toast.showRed("请选择预约日期");
        return;
      }
      
      // 组合日期
      const year = this.appointmentYear.replace("年", "");
      const month = this.appointmentMonth.replace("月", "").padStart(2, '0');
      const day = this.appointmentDay.replace("日", "").padStart(2, '0');
      const appointmentDate = `${year}-${month}-${day}`;
      
      const result = {
        userId: this.userId,
        appointmentDate: appointmentDate,
        remark: this.remark,
        deviceSn: this.selectedDeviceId || "", // 如果没有选择设备，传空字符串
      };
      
      // 如果是编辑模式，添加id
      if (this.isEditMode) {
        result.id = this.editData.id;
      }
      
      this.$emit("onConfirmClick", result);
    },
  },

  watch: {
    appointmentMonth(newValue) {
      this.calculateAppointmentDay(newValue);
    },
    appointmentYear(newValue) {
      if (newValue) {
        this.calculateAppointmentDay(this.appointmentMonth);
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.add-device {
  width: rem(550);

  &-top {
    width: 100%;
    height: rem(55);
    border-bottom: rem(1) solid rgba($color: black, $alpha: 0.09);
    box-sizing: border-box;
    padding: rem(0) rem(24);
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-title {
      color: rgba($color: black, $alpha: 0.85);
      font-size: rem(16);
    }

    &-close {
      width: rem(16);
      height: rem(16);
    }
  }

  &-middle {
    color: rgba($color: black, $alpha: 0.85);
    font-size: rem(14);
    line-height: rem(20);
    border-bottom: rem(1) solid rgba($color: black, $alpha: 0.09);
    width: 100%;
    max-height: rem(600);
    overflow-y: auto;
    padding: rem(20) rem(24);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: rem(16);

    .required {
      color: #ff4d4f;
    }

    &-user {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-search-container {
        width: 100%;
        height: rem(39);
        position: relative;
      }

    }

    &-device {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-search-container {
        width: 100%;
        height: rem(39);
        position: relative;
      }
    }

    &-appointment-date {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-container {
        display: flex;
        gap: rem(8);
        align-items: center;
        width: 100%;
      }

      &-year {
        flex: 1;
        min-width: rem(80);
        height: rem(32);
        
        ::v-deep .el-input {
          height: rem(32);
        }
        
        ::v-deep .el-input__suffix {
          display: flex;
          align-items: center;
        }
      }

      &-month {
        flex: 1;
        min-width: rem(70);
        height: rem(32);
        
        ::v-deep .el-input {
          height: rem(32);
        }
        
        ::v-deep .el-input__suffix {
          display: flex;
          align-items: center;
        }
      }

      &-day {
        flex: 1;
        min-width: rem(70);
        height: rem(32);
        
        ::v-deep .el-input {
          height: rem(32);
        }
        
        ::v-deep .el-input__suffix {
          display: flex;
          align-items: center;
        }
      }
    }

    &-remark {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-textarea {
        ::v-deep .el-textarea__inner {
          min-height: rem(80);
        }
      }
    }
  }

  &-bottom {
    width: 100%;
    height: rem(73);
    box-sizing: border-box;
    padding-top: rem(10);
    padding-right: rem(16);
    display: flex;
    justify-content: flex-end;

    &-confirm {
      color: white;
      background-color: #325FAC;
      font-size: rem(14);
      border-radius: rem(3);
      width: rem(65);
      height: rem(32);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-cancel {
      color: rgba($color: #000000, $alpha: 0.65);
      background-color: white;
      font-size: rem(14);
      border-radius: rem(3);
      border: rem(1) solid #e8e8e8;
      width: rem(65);
      height: rem(32);
      margin-right: rem(8);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

// 用户搜索框样式
.user-search {
  background-color: white;
  border: rem(1) solid #dcdfe6;
  border-radius: rem(4);
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-left: rem(15);
  padding-right: rem(5);
  display: flex;
  align-items: center;
  justify-content: space-between;

  &-input {
    color: black;
    opacity: 0.65;
    font-size: rem(14);
    border: none;
    outline: none;
    flex: 1;

    &::-webkit-input-placeholder {
      color: #909399;
      font-size: rem(14);
    }
  }

  &-search {
    color: white;
    background-color: #325FAC;
    font-size: rem(14);
    border-radius: rem(4);
    width: rem(48);
    height: rem(30);
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background-color: rgb(91, 127, 189);
    }
    
    &:active {
      background-color: rgb(45, 86, 155);
    }
  }

  &-clear {
    color: #909399;
    background-color: transparent;
    font-size: rem(16);
    border-radius: rem(4);
    width: rem(30);
    height: rem(30);
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: #f56c6c;
      background-color: rgba(245, 108, 108, 0.1);
    }
    
    &:active {
      color: #dd6161;
    }
  }

  &.active {
    border: rem(1) solid #325FAC;
  }
}

// 设备搜索框样式
.device-search {
  background-color: white;
  border: rem(1) solid #dcdfe6;
  border-radius: rem(4);
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-left: rem(15);
  padding-right: rem(5);
  display: flex;
  align-items: center;
  justify-content: space-between;

  &-input {
    color: black;
    opacity: 0.65;
    font-size: rem(14);
    border: none;
    outline: none;
    flex: 1;

    &::-webkit-input-placeholder {
      color: #909399;
      font-size: rem(14);
    }
  }

  &-search {
    color: white;
    background-color: #325FAC;
    font-size: rem(14);
    border-radius: rem(4);
    width: rem(48);
    height: rem(30);
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background-color: rgb(91, 127, 189);
    }
    
    &:active {
      background-color: rgb(45, 86, 155);
    }
  }

  &-clear {
    color: #909399;
    background-color: transparent;
    font-size: rem(16);
    border-radius: rem(4);
    width: rem(30);
    height: rem(30);
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: #f56c6c;
      background-color: rgba(245, 108, 108, 0.1);
    }
    
    &:active {
      color: #dd6161;
    }
  }

  &.active {
    border: rem(1) solid #325FAC;
  }
}

// 设备列表样式
.device-list-container {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: white;
  border: rem(1) solid #dcdfe6;
  border-radius: rem(4);
  box-shadow: 0 rem(2) rem(12) rgba(0, 0, 0, 0.1);
  max-height: rem(200);
  overflow-y: auto;
  margin-top: rem(4);

  .device-list {
    .device-list-item {
      padding: rem(12) rem(15);
      border-bottom: rem(1) solid #f0f0f0;
      cursor: pointer;
      transition: background-color 0.2s;

      &:hover {
        background-color: #f5f7fa;
      }

      &:last-child {
        border-bottom: none;
      }

      .device-item-info {
        .device-item-name {
          color: #4d4f5c;
          font-size: rem(14);
          font-weight: 500;
          margin: 0 0 rem(4) 0;
        }

        .device-item-details {
          color: #909399;
          font-size: rem(12);
          margin: 0;
        }
      }
    }
  }
}

// 用户列表样式
.user-list-container {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: white;
  border: rem(1) solid #dcdfe6;
  border-radius: rem(4);
  box-shadow: 0 rem(2) rem(12) rgba(0, 0, 0, 0.1);
  max-height: rem(200);
  overflow-y: auto;
  margin-top: rem(4);

  .user-list {
    .user-list-item {
      padding: rem(12) rem(15);
      border-bottom: rem(1) solid #f0f0f0;
      cursor: pointer;
      transition: background-color 0.2s;

      &:hover {
        background-color: #f5f7fa;
      }

      &:last-child {
        border-bottom: none;
      }

      .user-item-info {
        .user-item-name {
          color: #4d4f5c;
          font-size: rem(14);
          font-weight: 500;
          margin: 0 0 rem(4) 0;
        }

        .user-item-details {
          color: #909399;
          font-size: rem(12);
          margin: 0 0 rem(2) 0;
        }

        .user-item-date {
          color: #c0c4cc;
          font-size: rem(11);
          margin: 0;
        }
      }
    }
  }
}
</style>